import type { FormEvent } from 'react';
import { useFormSubmit } from '@/hooks/useFormSubmit';

const SUBSCRIBE_ENDPOINT = 'https://readdy.ai/api/form/dailpf3p14a1h3mr76g0';

export default function SubscribeSection() {
  const { status, message, submit } = useFormSubmit(
    SUBSCRIBE_ENDPOINT,
    '订阅成功，我们会把每期速览汇总发到你的邮箱。',
  );

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    submit(event.currentTarget);
  };

  return (
    <section id="subscribe" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-accent-100">
          <div className="grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-2 lg:items-center lg:gap-12">
            <div>
              <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.24em] text-accent-800">
                <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
                Newsletter
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
                订阅速览，每期一次读完全网热点
              </h2>
              <p className="mt-3 max-w-md font-body text-sm leading-relaxed text-foreground-700">
                工作日上午更新后，我们会把当期最值得看的速览要点汇总成一封邮件。没有广告，随时可以取消。
              </p>
            </div>

            <form
              id="kanliao-subscribe-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="rounded-lg border border-accent-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex flex-col gap-3 sm:flex-row">
                <input
                  type="text"
                  name="nickname"
                  placeholder="你的称呼（可选）"
                  aria-label="你的称呼"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-body text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="你的邮箱地址"
                  aria-label="你的邮箱地址"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-2.5 font-body text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                />
              </div>

              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="alt-contact-field"
              />

              <button
                type="submit"
                disabled={status === 'submitting'}
                className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
              >
                <i className="ri-send-plane-line text-base" aria-hidden="true"></i>
                {status === 'submitting' ? '提交中…' : '免费订阅速览'}
              </button>

              {message && (
                <p
                  role="status"
                  className={`mt-3 font-body text-sm ${
                    status === 'success' ? 'text-secondary-700' : 'text-primary-600'
                  }`}
                >
                  {message}
                </p>
              )}

              <p className="mt-3 font-body text-xs leading-relaxed text-foreground-500">
                订阅即表示你同意我们仅将邮箱用于发送速览汇总，不会用于其他用途。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}